module.exports = __webpack_public_path__ + "img/power_white.f1388f22.png";